export { default as leftPhoneLottieData } from './left_phone-lottie.json';
export { default as rightPhoneLottieData } from './right_phone-lottie.json';
export { default as thereWhenNeededImg } from './there_when_needed.svg';
export { default as fastHelpImg } from './fast_help.svg';
